// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ipzYr","right":"styles_right__iXTyS"};